export const proServicesKeys = [
  "additionalCoaching",
  "ecovadis",
  "vsme",
  "cdpAssessment",
  "climateFresk",
];
